export default __webpack_public_path__ + "static/ActaHeadline-Book-c8d50c4bc4d9de5067a77f0bdbb7eada.woff";